









import { Component, Vue } from "vue-property-decorator";
import { Mutation } from "vuex-class";
import { rootMutationNames } from "@/store";

@Component
export default class AppBar extends Vue {
  @Mutation(rootMutationNames.TOGGLE_DRAWER) toggleDrawerMutation;
}
